import React from "react";

import {
  bookingCardStyles,
  footer,
} from "components/Pdfs/BookingCardLandscape";

import {
  createAndOpenPdf,
  getClearingSaleTableData,
  getSaleAndDocumentInformation,
  headerVerticalOffset,
  pageMarginHorizontal,
} from "lib/pdf";
import { History } from "history";

const columnWidths = [50, 25, 180, 150, 60, "*"];
const pageMarginTop = 40 + headerVerticalOffset;
const pageMarginBottom = 20;
const isSignOffReport = true;

// Render the outer tables, one for each lane.
const getContent = (
  saleLots: SaleLot[],
  blankRowHeight: number,
  extraSpacing: boolean,
) => {
  const tableHeaders = [
    { text: "LOT", style: "tableHeader" },
    { text: "QTY", style: "tableHeader" },
    { text: "VENDOR", style: "tableHeader" },
    { text: "DESCRIPTION", style: "tableHeader" },
    { text: "PRICE", style: "tableHeader" },
    { text: "BUYER", style: "tableHeader" },
  ];

  const lanes = [saleLots].map((_, i) => {
    const laneTableData = getClearingSaleTableData(
      saleLots,
      blankRowHeight,
      extraSpacing,
      columnWidths,
    );

    return {
      pageBreak: i > 0 ? "before" : null,
      table: {
        headerRows: 1,
        dontBreakRows: true,
        widths: ["*"],
        body: [
          [
            {
              border: [false, false, false, false, false],
              table: {
                headerRows: 0,
                dontBreakRows: true,
                widths: columnWidths,
                body: [tableHeaders],
              },
            },
          ],
          ...laneTableData,
        ],
      },
    };
  });

  return lanes;
};

interface ClearingSaleBookingCardProps {
  saleLots: SaleLot[];
  sale: Sale;
  agencyName: string;
  history: History;
  extraSpacing: boolean;
  deploymentLogo?: string;
  saleLogo?: string;
}

export const BookingCardClearingSale = ({
  saleLots,
  sale,
  agencyName,
  history,
  extraSpacing,
  deploymentLogo,
  saleLogo,
}: ClearingSaleBookingCardProps) => {
  const blankRowHeight = 50;
  const pdfDefinition = {
    pageSize: "A4",
    pageOrientation: "landscape",
    pageMargins: [
      pageMarginHorizontal,
      pageMarginTop,
      pageMarginHorizontal,
      pageMarginBottom,
    ],
    content: getContent(saleLots, blankRowHeight, extraSpacing),
    images: {
      logo: deploymentLogo || saleLogo,
    },
    header: getSaleAndDocumentInformation({
      auctionPens: [],
      sale,
      agencyName,
      round: null,
      isHeader: true,
      includeLogo: isSignOffReport,
      logoName: "logo",
      saleLots,
    }),
    ...footer,
    styles: bookingCardStyles,
  };

  createAndOpenPdf(pdfDefinition, history);

  return <div />;
};
